import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaSearch from 'react-icons/lib/fa/search';

import {
    Typography,
    WDSButton,
    LoadingDots,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './SearchButton.scss';

function SearchButton(props) {
    const {
        className,
        disabled = false,
        loading,
        noLabel = false,
        onClick = () => undefined,
        t,
    } = props;

    return (
        <WDSButton
            className={`${className} ${styles.searchButton}`}
            color="secondary"
            disabled={disabled}
            label={t('Search')}
            onClick={onClick}
        >
            {noLabel
                ? (
                    <FaSearch
                        aria-hidden={true}
                        className={classNames(
                            styles.searchIcon,
                            { [styles.hideElement]: loading },
                        )}
                        focusable={false}
                    />
                )
                : (
                    <Typography
                        className={classNames({ [styles.hideElement]: loading })}
                        variant="subtitle"
                    >
                        {t('baseApp:Search')}
                    </Typography>
                )}
            {loading && (
                <LoadingDots
                    className={styles.dotContainer}
                    dotClassName={styles.dots}
                />
            )}
        </WDSButton>
    );
}

SearchButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    noLabel: PropTypes.bool,
    onClick: PropTypes.func,
    t: PropTypes.func,
};

export { SearchButton };
export default localize(SearchButton);
